import advanceLoading from 'features/advance/localization/advanceLoadingScreenString.en';
import accountPending from 'features/advance/screens/registration/AccountPending/accountPendingStrings.en';
import amountSelection from 'features/advance/screens/registration/AdvanceAmountSelection/amountSelectionStrings.en';
import autopayment from 'features/advance/screens/registration/AutoPaymentScreen/autoPaymentStrings.en';
import employmentInfo from 'features/advance/screens/registration/EmploymentInfo/employmentInfoStrings.en';

export const error = {
  title: 'Oops! Something went wrong.',
  body: 'Please try again later',
  button: 'Done',
};
const autopaymentAuthorizationStrings = {
  error: {
    ...error,
  },
  agreement:
    'I authorize Varo to withdraw a one-time payment from my {{paymentMethod}} on my autopay date.',
  button: 'Continue',
  title: 'Autopay Authorization',
};

const review = {
  title: 'Review',
  body: 'The money will arrive in your Varo Bank Account instantly.',
  buttons: {
    getAdvance: 'Get Advance',
    cancel: 'Cancel',
    gotIt: 'Got it',
    review: 'Review',
  },
  note: 'Once you tap “Get Advance” you can’t change or cancel your Advance amount, autopay date or autopay method, so review carefully. By getting an Advance, I authorize Varo to withdraw {{amount}} from my Varo Bank Account on {{advanceDate}}.',
  noteV2:
    'Once you tap “Get Advance” you can’t change your Advance amount, autopay date or autopay method, so review carefully.',
  amountTitle: 'Advance amount',
  fee: 'Fee',
  total: 'Total',
  autoPaymentDateTitle: 'Autopay date',
  amountDueOn: 'Amount due on',
  autoPaymentMethod: `Autopay method`,
  backupPaymentTermsTitle: 'Past Due Payment Terms',
  backupMethodsTitle: 'Past due payment methods',
  backupMethodsNote:
    'Varo will automatically pull repayment funds from the accounts and cards you have connected to the Varo app.',
  message:
    'Nice! Your {{advanceAmount}} Advance was added to your Varo Bank Account.',
  error: {
    noData: 'No data provided',
    title: 'Oops! something went wrong.',
    body: 'Please try again later.',
    button: 'Done',
  },
  lightningDebitTermsAndConditions:
    'I authorize Varo to withdraw a one-time payment from my linked debit card.',
  lightningAchTermsAndConditions:
    'I authorize Varo to withdraw a one-time ACH (“Automated Clearing House”) payment from my linked account.',
  lightningTermsAndConditions:
    'I authorize Varo to withdraw a one-time ACH (“Automated Clearing House”) payment from my linked account.',
  debitAgreementTitle: 'Linked Debit Card Authorization',
  achAgreementTitle: 'Linked Account ACH Authorization',
  bottomSheet: {
    dynamicAgreement: {
      bottomSheetTitle: 'Linked Account ACH Authorization',
    },
    paymentMethods: {
      title: 'Past due payment methods',
      body: 'If your repayments become past due, Varo will automatically pull money for repayment from your accounts in this order.',
    },
    autopayMethods: {
      title: 'Payment from',
    },
  },
};

const whatIsVaStrings = {
  title: 'Advance',
  termsAndConditions: '* Additional qualifications apply',
  advanceWithInMinutes: 'Advances arrive within minutes',
  doneButton: 'Done',
  noCreditScoreImpact: 'No impact to your credit score',
  zeroInterest: 'Easy, zero interest, and affordable',
  unlockLargeAmount: 'Unlock higher amounts with larger direct deposits',
  secondaryText:
    'Move your paycheck to Varo to get a spot of $20-$250 and grow your limit to $1,000 over time.',
  headLineText: 'Get up to $1,000\nCash Advance.',
  directDepositButton: 'Set up direct deposit',
  manageDirectDepositButton: 'Manage direct deposit',
  cancelButton: 'Cancel',
  errorTitle: error.title,
  errorMessage: error.body,
  eligibilityRequirementsLabel: 'eligibility requirements.',
};

const lightningIntro = {
  title: 'Advance',
  headLineText: 'Get a cash advance',
  secondaryText: 'Link a qualifying bank account to get up to $250 in minutes.',
  flatFee: 'One flat fee',
  noCreditCheck: 'No credit check',
  flexibleRepayment: 'Flexible repayment',
  buttonContinue: 'Continue',
  termsAndConditions:
    'Qualifications apply. Subject to evaluation of consumer reports and Varo account activity.',
};

const linkAccountLoadingStrings = {
  body: 'Stay on this page and give us just a moment to wrap up.',
  processing: 'Processing',
  analyzing: 'Analyzing',
  finalizing: 'Finalizing',
};

const lightningLinkAccount = {
  buttons: {
    existingAccount: 'Use my existing linked account',
    newAccount: 'Link a new account',
    linkAnAccount: 'Link an account',
    useExistingAccount: 'Use existing account',
    addAnAccount: 'Add an account',
    addADifferentAccount: 'Add a different account',
  },
  loadingScreen: {
    ...linkAccountLoadingStrings,
  },
  errorTitle: error.title,
  errorBody: error.body,
  errorButton: error.button,
};

const lightningEligibility = {
  buttons: {
    setUpDD: 'Set up direct deposit',
    newAccount: 'Link a new account',
    manageDD: 'Manage direct deposit',
    addDifferentAccount: 'Add a different account',
  },
  loadingScreen: {
    ...linkAccountLoadingStrings,
  },
  errorButton: error.button,
};

const lcmDirectDeposit = {
  button: {
    setUpDD: 'Set up direct deposit',
    manageDD: 'Manage direct deposit',
  },
  termsLinkText: 'Terms and Conditions',
};

const pending = {
  title: 'We’re finalizing your linked account',
  description:
    "You'll see a status update on the Varo Advance tile on your home tab.",
  buttonDone: 'Done',
};

const throttling = {
  title: 'Advance',
  buttonGotIt: 'Got it',
  errorButton: error.button,
};

const manualRepay = {
  limitError: "You can't repay more than the amount due {{amountDue}}.",
  limitErrorStart: 'You will owe {{pendingAmount}} on {{paymentDueDate}}',
  yourLimit: 'Your limit for this transfer is {{availableBalance}}',
  debitCardMinimumPaymentError:
    'Your minimum payment amount with a debit card is {{minimumPayment}}',
  from: 'From:',
  selectAnAccount: 'Select an account',
  button: 'Next',
  available: 'Available:',
  errorMessage: 'oops something went wrong',
  title: 'Repay Advance',
  debitCardText: 'Link a debit card',
  linkDebitCardTitle: 'Repay instantly with a debit card',
  linkDebitCardText:
    'Link your debit card to pay back your Advance instantly and get access to borrow again faster.',
  addDebitCard: 'Add a debit card',
  notRightNow: 'Not right now',
};

const advanceInTheWorksStrings = {
  title: 'Your advance is in the works',
  description:
    'We’ll let you know when the money arrives in your Varo Bank Account.',
  doneButton: 'Done',
};

const getAdvanceSuccessStrings = {
  getAdvanceSuccessfulLabel: 'Money \nin the bank',
  getAdvanceSuccessfulEyebrow: 'Success',
  getAdvanceSuccessfulNewLabel: 'You received your\nAdvance',
  getAdvanceSuccessfulNewMessage:
    '{{advanceAmount}} was added to your Varo Bank Account.',
  encourageDdAfterVaSuccessBottomSheet: {
    body: 'Deposit $800 monthly to qualify.',
    primaryButton: 'Set up direct deposit',
    secondaryButton: 'Skip for now',
    titleHigherFee: 'Get 50% off future Advance fees!',
  },
  doneButton: 'Done',
  transferInstantlyButton: 'Transfer instantly',
};

const advanceConfirmPaymentStrings = {
  confirmPayment: 'Confirm payment',
  paymentAmount: 'Payment amount',
  repayFrom: 'Repay from',
  errorTitle: error.title,
  errorBody: error.body,
  errorButton: error.button,
  achDisclaimer:
    'By tapping “Confirm payment”, I authorize Varo Bank to make a one time ACH payment of ${{repayAmount}} from {{accountName}} to my Varo Advance on {{todaysDate}}. Same day payment authorizations cannot be canceled once confirmed.',
  debitCardDisclaimer:
    'By tapping “Confirm payment”, I authorize Varo Bank to make a one time debit card payment of ${{repayAmount}} from {{accountName}}  to my Varo Advance on {{todaysDate}}. Same day payment authorizations cannot be canceled once confirmed.',
};

const repaymentSuccessStrings = {
  buttons: {
    done: 'Done',
  },
};

const advanceQualifiedStrings = {
  congratulationTitle: 'Congrats!',
  approvalTitle: 'You’re approved \nfor',
  approvalDescription:
    'You can grow your limit over time the more you bank, borrow, and make on-time payments.*',
  additionalQualificationsNote: '*Additional qualifications may apply.',
  borrowNowButtonLabel: 'Borrow now',
  borrowLaterButtonLabel: 'Borrow later',
  noteLabel:
    '*Additional qualifications may apply. You may be required to provide both debit card and ACH payment authorizations to access Advance funds.',
};

const linkDebitCard = {
  title: 'Link your external debit card to borrow {{advanceAmount}}',
  description:
    "Make sure it's associated with your {{bankName}} checking account ending in {{last4}}. This card will be used as a backup payment to repay any Advances you take.",
  subDescription:
    "You're linking this debit card in order to provide payment authorization should your account go past due.",
  link: 'Learn more about past due payment methods',
  linkButton: 'Link a debit card',
  viewCards: 'View cards',
  expiredCardTitle: 'An active linked debit card is required to continue',
  expiredCardMessage:
    'Remove and relink your debit card or try again with a different one.',
  errorTitle: error.title,
  errorBody: error.body,
  errorButton: error.button,
};

const getHigherAdvanceStrings = {
  title: 'Start your journey with {{qualifiedAmount}}',
  description:
    'Want more? Add direct deposit today, get lower fees and up to $1,000 over time.',
  bullets: {
    first: 'Get {{qualifiedAmount}} today',
    second: 'Set up direct deposit in seconds',
    third:
      'Borrow more and pay lower fees with $800+ in qualifying direct deposits',
  },
  disclaimerText:
    "You're approved to borrow {{qualifiedAmount}} now with or without setting up direct deposit.",
  buttons: {
    directDeposit: 'Set up direct deposit',
    continue: 'Continue without direct deposit',
  },
};

const advanceConsumerReportPermissionScreenStrings = {
  buttons: {
    primary: 'Add a different account',
  },
  loadingScreen: {
    ...linkAccountLoadingStrings,
  },
  error: {
    title: 'Oops! Something went wrong.',
    body: 'Please try again later',
    button: 'Done',
  },
};

const ddBorrowMore = {
  title: 'Advance',
  headline: 'Borrow more, pay less',
  body: 'Get a cash Advance of up to $250 today! Set up direct deposit to increase your limit over time and cut fees in half once deposits are received.',
  withDD: {
    tag: 'Recommended',
    title: 'Continue with direct deposit',
    description:
      'Customers with {{minDirectDepositAmount}}+ in direct deposit can borrow up to {{maxAdvanceLimit}} over time and pay lower fees on future Advances. By continuing, you will be taken to set up direct deposit.',
  },
  withoutDD: {
    title: 'Continue without direct deposit',
    description:
      'You can still apply, customers without direct deposits have lower limits and standard fees.',
  },
  disclaimer:
    'Qualifications apply. Subject to evaluation of consumer reports and Varo account activity. Once approved, you can borrow today with or without setting up direct deposit.',
  button: 'Get an Advance',
};

const takeOutAdvanceDdPrompt = {
  title: 'Advance',
  headline: 'Borrow more, pay less',
  body: 'Set up direct deposit to increase your limit over time and cut fees in half once deposits are received.',
  withDD: {
    tag: 'Recommended',
    title: 'Continue with direct deposit',
    description:
      'Customers with {{minDirectDepositAmount}}+ in direct deposit can borrow up to {{maxAdvanceLimit}} over time and pay lower fees on future Advances. By continuing, you will be taken to set up direct deposit.',
  },
  withoutDD: {
    title: 'Continue without direct deposit',
    description:
      'Customers without direct deposits have lower limits and standard fees.',
  },
  disclaimer: 'You can borrow today with or without setting up direct deposit.',
  button: 'Get an Advance',
};

export default {
  autopaymentAuthorizationStrings,
  accountPending,
  advanceLoading,
  manualRepay,
  autopayment,
  amountSelection,
  employmentInfo,
  error,
  pending,
  throttling,
  advanceInTheWorksStrings,
  advanceConfirmPaymentStrings,
  getAdvanceSuccessStrings,
  advanceQualifiedStrings,
  repaymentSuccessStrings,
  review,
  whatIsVaStrings,
  lightningIntro,
  lightningLinkAccount,
  lightningEligibility,
  lcmDirectDeposit,
  linkDebitCard,
  manageAdvanceAccount: {
    title: 'Manage Account',
    listItemScreenOptions: {
      advanceHistory: 'Advance history',
      monthlyStatements: 'Statements and documents',
      whatIsVaroAdvance: 'What is Varo Advance?',
      varoAdvanceFAQs: 'Varo Advance FAQs',
      termsAndConditions: 'Terms and conditions',
    },
  },
  advanceDetails: {
    title: 'Advance details',
    listItems: {
      advanceDate: 'Advance date',
      payments: 'Payment',
      fee: 'Fee',
      Total: 'Total',
      advance: 'Advance',
      advanceHistory: 'Advance history',
      noHistoryBody: 'Your activity will be shown here.',
      noHistoryTitle: 'No history',
      noStatements: 'No Statements',
      noHistoryButtonText: 'Take out an Advance',
    },
    amountTitle: 'Advance amount',
    varoAdvanceFee: 'Varo Advance Fee',
    varoAdvance: 'Varo Advance',
  },
  getHigherAdvanceStrings,
  advanceConsumerReportPermissionScreenStrings,
  ddBorrowMore,
  takeOutAdvanceDdPrompt,
};
